import dummyImg from "../../assets/images/dummyImg.png";

export const OPTIONS = [
  {
    label: "General Medicine",
    tags: ["Covid19", "Asthma", "Impact sessions"],
    icon: dummyImg,
    sectionId: "NewInAHA",
  },
  {
    label: "Cardiology",
    tags: ["Covid19", "Asthma", "COPD", "Telemedicine"],
    icon: dummyImg,
    sectionId: "OnlyOnDocflix",
  },
  {
    label: "Critical Care Medicine",
    tags: ["Covid19", "Pediatric Asthma"],
    icon: dummyImg,
    sectionId: "CaseFlix",
  },
  {
    label: "Dermatology",
    tags: ["Covid19", "Asthma", "Bronchiectasis"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Dentistry",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Diabetology",
    tags: ["Covid19", "Telemedicine"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "ENT",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Gastroenterology & Hepatology",
    tags: ["Covid19", "Asthma", "Pulmonary Hypertension"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "HIV / AIDS",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Infectious Diseases",
    tags: ["Covid19", "Pulmonary Hypertension", "ILD/PF"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Musculoskeletal Diseases",
    tags: ["Covid19", "Pediatric Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Neuropsychiatry",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Obstetrics & Gynaecology",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Oncology",
    tags: [
      "Asthma",
      // "Allergic Rhinitis",
      "Covid19",
      "Diagnosis",
      "Heart failure",
      // "Telemedicine",
      // "ILD/PF",
      // "Pulmonary Hypertension",
      // "Pediatric Asthma",
    ],
    icon: dummyImg,
    sectionId: "OnlyOnDocflix",
  },
  {
    label: "Ophthalmology",
    tags: ["Covid19", "Pediatric Asthma", "Pulmonary Hypertension", "ILD/PF"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Pediatrics",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Respiratory Medicine",
    tags: ["Covid19", "ILD/PF"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Surgery",
    tags: ["Covid19", "Asthma"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
  {
    label: "Urology",
    tags: ["Covid19", "ILD/PF"],
    icon: dummyImg,
    sectionId: "HighlyRatedVideos",
  },
];
